import { render, staticRenderFns } from "./xgPersonal.vue?vue&type=template&id=7c234521&scoped=true&"
import script from "./xgPersonal.vue?vue&type=script&lang=js&"
export * from "./xgPersonal.vue?vue&type=script&lang=js&"
import style0 from "./xgPersonal.vue?vue&type=style&index=0&id=7c234521&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c234521",
  null
  
)

export default component.exports